export * from './IconPencil';
export { default as IconPencil } from './IconPencil';
